/**
 * Conversation Icon Component
 * Renders either the Xavior logo marker or a neutral monochrome glyph.
 * Emoji-based conversation icons are intentionally suppressed in chat surfaces.
 */

import type { CSSProperties, JSX } from 'react';

interface ConversationIconProps {
  icon?: string | null;
  className?: string;
  style?: CSSProperties;
}

function NeutralConversationGlyph({
  className = '',
  style,
}: {
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={`conversation-icon-glyph ${className}`.trim()}
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      style={style}
    >
      <rect x="4" y="5" width="16" height="12" rx="3" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 11H15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M11 20L13.5 17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function ConversationIcon({ icon, className = '', style }: ConversationIconProps) {
  if (icon === ':xavior-logo:') {
    return (
      <img
        src="/favicon.svg"
        alt="Xavior"
        className={`conversation-icon-logo ${className}`.trim()}
        style={style}
      />
    );
  }

  return <NeutralConversationGlyph className={className} style={style} />;
}

export function renderConversationIcon(icon?: string | null): JSX.Element {
  return <ConversationIcon icon={icon} />;
}
